import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative z-10 rounded-lg border-2 border-gray-400 max-w-7xl bg-primary-background-color mx-2 lg:p-10 p-5" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-10 lg:gap-20 items-center mb-10 lg:mb-20 box-border lg:px-10 pt-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "leading-loose text-gray-700" }, "I've collected a small selection of personal projects and work that I value greatly. These items in particular show the additional effort I have invested in them, forming a noticeable pattern.", -1)
const _hoisted_4 = { class: "flex justify-start gap-5 lg:px-10 mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "APPLICATIONS", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "DESIGNS", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "grid lg:grid-cols-2 gap-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GalleryHeading = _resolveComponent("GalleryHeading")!
  const _component_GalleryApplication = _resolveComponent("GalleryApplication")!
  const _component_GalleryDesign = _resolveComponent("GalleryDesign")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_GalleryHeading, { class: "w-2/3 lg:w-auto" }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeGallery('projects'))),
        class: _normalizeClass(["flex items-center gap-8 text-white bg-[#292929] hover:opacity-75 py-3 px-5 rounded-lg", {'bg-primary-focus': _ctx.selectedGallery === 'projects'}])
      }, _hoisted_6, 2),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeGallery('designs'))),
        class: _normalizeClass(["flex items-center gap-8 text-white bg-[#292929] hover:opacity-75 py-3 px-5 rounded-lg", {'bg-primary-focus': _ctx.selectedGallery === 'designs'}])
      }, _hoisted_8, 2)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
        return _withDirectives((_openBlock(), _createBlock(_component_GalleryApplication, {
          key: project.id,
          project: project
        }, null, 8, ["project"])), [
          [_vShow, _ctx.selectedGallery === 'projects']
        ])
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designs, (design) => {
        return _withDirectives((_openBlock(), _createBlock(_component_GalleryDesign, {
          key: design.id,
          design: design
        }, null, 8, ["design"])), [
          [_vShow, _ctx.selectedGallery === 'designs']
        ])
      }), 128))
    ])
  ]))
}